<template>
<div class="container container-720">
  <h3>User</h3>
  <Divider />
  <Form :model="form" label-position="top">
    <FormItem label="Full Name">
      <Input v-model="form.fullName" placeholder=""></Input>
    </FormItem>
    <FormItem label="Email">
      <Input type="email" v-model="form.email" placeholder=""></Input>
    </FormItem>
    <FormItem label="Role">
      <Select v-model="form.role" style="width:200px">
          <Option value="user">User</Option>
          <Option value="admin">Admin</Option>
      </Select>
    </FormItem>
    <div v-if="!$route.params.id"> 
      <FormItem label="Password">
        <Input type="password" v-model="form.password" placeholder=""></Input>
      </FormItem>
      <FormItem label="Confirm Password">
        <Input type="password" v-model="form.password2" placeholder=""></Input>
      </FormItem>
    </div>
    <FormItem>
    <Button type="primary" @click="saveUser()" style="float:right;">Save</Button>
    </FormItem>
  </Form>
</div>
</template>

<script>
import {
  mapActions
} from "vuex";

export default {
  data() {
    return {
      form: {},
      isPending: false,
    };
  },
  methods: {
    ...mapActions("users", {
      createUserAction: "create",
      updateUserAction: "patch",
      getUserAction: "get"
    }),
    ...mapActions("auth", ["authenticate"]),
    ...mapActions("appsettings", {
      'updateAppSettings': "patch"
    }),
    saveUser(){
      if (this.$route.params.id) {
        this.updateUser()
      } else {
        this.createUser()
      }
    },
    createUser() {
      this.$set(this.$data, 'isPending', true)

      const params = {
        fullName: this.$data.form.fullName,
        email: this.$data.form.email,
        password: this.$data.form.password,
        role: this.$data.form.role
      };
      
      this.createUserAction(this.$data.form).then((response) => {

          this.updateAppSettings([
            this.$store.state.appsettings.copy._id,
            {
              isFirstInit: false,
              hasAdmin: true,
            },
            {}
          ]);

          this.$set(this.$data, 'isPending', false)
          this.$Message.success('User has beed updated')
          this.$router.replace('/user/list')

      }).catch(error => console.log(error));
    },
    updateUser(){
      const params = {
        fullName: this.$data.form.fullName,
        email: this.$data.form.email,
        role: this.$data.form.role
      };
      this.updateUserAction([this.$route.params.id, params]).then((user)=>{
        this.$set(this.$data, 'isPending', false)
        this.$Message.success('User has beed updated')
        this.$router.replace('/user/list')
      })
    }
  },
  created(){
    if (this.$route.params.id) {
      this.getUserAction(this.$route.params.id).then((user)=>{
        this.$data.form = _.cloneDeep(user);
      });
    }
  }
};
</script>

<style>

</style>
